// removed by extract-text-webpack-plugin
module.exports = {"form":"c-AddressForm__form","checkbox":"c-AddressForm__checkbox","fields":"c-AddressForm__fields","addressReadOnly":"c-AddressForm__addressReadOnly"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/AddressForm/AddressForm.scss
// module id = 936
// module chunks = 0